import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
// import Home from "./containers/user/dashboard/MobileViewDashboard";
import ActivateAccount from "./containers/onboarding/activateAccount";
import VerifyProfile from "./containers/onboarding/verifyProfile/verifyProfile";
import AddImagePage from "./containers/onboarding/AddImagePage";
// import AddSocialLogin from "./containers/onboarding/AddSocialLogin";
import CreateNewPassword from "./containers/onboarding/CreateNewPassword";
import CompleteUserProfile from "./containers/onboarding/CompleteUserProfile";
import Secretariat from "./containers/secretariat";
import Announcement from "./containers/secretariat/announcement/AnnouncementHome";
import CareerHome from "./containers/secretariat/career/CareerHome";
import CareerDetails from "./containers/secretariat/career/CareerDetails";
import AnnouncementDetails from "./containers/secretariat/announcement/AnnouncementDetails";
import FAQ from "./containers/secretariat/faq/Faq";
import DocProcessing from "./containers/docProcessing";
import CertProcessing from "./containers/docProcessing/certificate/CertProcessing";
import TranscriptUnofficial from "./containers/docProcessing/transcript/TranscriptUnofficial";
import TranscriptOfficial from "./containers/docProcessing/transcript/TranscriptOfficial";
import OfficialLetter from "./containers/docProcessing/officialletter/OfficialLetter";
import MemberDirectory from "./containers/secretariat/member-directory/MemberDirectoryHome";
import VerifyPayment from "./containers/docProcessing/cart/VerifyPayment";
import CartPage from "./containers/docProcessing/cart/CartPage";
// import SuperAdminHome from "./containers/SuperAdmin/Home";
// import SuperAdminViewFee from "./containers/superAdmin/Fees/ViewFees";
// import Login from "./containers/auth/login";
import Login from "./containers/auth/SignIn";
import ForgotPassword from "./containers/auth/ForgotPassword";
import Error404 from "./containers/landing/Error404";
import TokenHelpers from "./utils/helpers/tokenHelper";
// import cookieHelper from "./utils/helpers/cookieHelper";
// import { configs } from "./utils/helpers/constants";
import EventHome from "./containers/event/EventHome";
import EventDetails from "./containers/event/EventDetails";
import CreateEvent from "./containers/event/CreateEvent";
import CommunityHome from "./containers/community/CommunityHome";
import PeopleHome from "./containers/people/PeopleHome";
import StudentProfile from "./containers/people/StudentProfile";
import CommunityDetails from "./containers/community/CommunityDetails";
import EditProfile from "./containers/user/Account/EditProfile";
import MemberProfile from "./containers/secretariat/member-directory/MemberProfile";
// import BottomNavBar from "./components/BottomNavBar";
// import Onboarding from "./containers/onboarding/GetStarted/Onboarding";
import ResetPassword from "./containers/auth/ResetPassword";
import UserProfile from "./containers/user/Profile/UserProfile";

//ADMIN
import Dashboard from "./containers/pageview/Home";
import AdminDocProcessing from "./containers/pageview/docprocessing/Home";
import AdminDocProcessingInstruction from "./containers/pageview/docprocessing/instruction/Home";
import AdminEvent from "./containers/pageview/event/Home";
import AdminCommunity from "./containers/pageview/community/Home";
import AdminMember from "./containers/pageview/member/Home";
import AdminFee from "./containers/pageview/fee/Home";
import AdminDeliveryFee from "./containers/pageview/delivery_station/Home";
import AdminFaq from "./containers/pageview/faq/Home";
import AdminAnnouncement from "./containers/pageview/announcement/Home";
import AdminCareerJob from "./containers/pageview/career/job/Home";
import AdminScholarshipJob from "./containers/pageview/career/scholarship/Home";
import AdminDocumentProcessingDetails from "./containers/pageview/docprocessing/DocumentProcessingDetails";
import PrivacyPolicy from "./containers/legal/PrivacyPolicy";
import TermsCondition from "./containers/legal/TermsCondition";
import PaymentBreakdownComponent from "./containers/docProcessing/PaymentBreakdownComponent";
import DocumentTracking from "./containers/docProcessing/tracking/DocumentTracking";
import DocumentTrackingDetails from "./containers/docProcessing/tracking/DocumentTrackingDetails";
import ModalRootContainer from "./components/modals/root";
import MainDashboardLayout from "./components/layouts/mainDashboardLayout";
import Message from "./containers/message";

const IsLoggedInRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      TokenHelpers.checkIfTokenExist() ? (
        <Component {...props} />
      ) : (
        <Redirect to={"/login"} />
      )
    }
  />
);

const ActivatedAccountRoute = ({ children, path, ...rest }) => {
  const renderFunc = ({ location }) => {
    // const accountStatus = cookieHelper.get(configs.USER_ACTIVATED_STATUS);
    const accountStatus = TokenHelpers.getUserStatus();
    if (accountStatus === "EXPIRED") {
      return (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: location },
          }}
        />
      );
    }
    const accountActivatedStatus = !(
      accountStatus === null ||
      accountStatus === "" ||
      accountStatus === "UNACTIVATED"
    );
    return accountActivatedStatus ? (
      <Switch>{children}</Switch>
    ) : (
      <Redirect
        to={{
          pathname: "/onboarding/activate-account",
          state: { from: location },
        }}
      />
    );
  };
  return <Route {...rest} render={renderFunc} />;
};

function App() {
  return (
    <Router>
      <Toaster />
      <ModalRootContainer />
      <Switch>
        {/* <Route path="/" component={Login} /> */}
        <Route path="/login" component={Login} />
        <Route exact path="/forgot-password" component={ForgotPassword} />
        <Route exact path="/reset-password" component={ResetPassword} />

        <Route
          exact
          path="/onboarding/activate-account"
          component={ActivateAccount}
        />
        <Route
          exact
          path="/onboarding/verify-profile"
          component={VerifyProfile}
        />
        <Route
          exact
          path="/onboarding/complete-profile"
          component={CompleteUserProfile}
        />
        <Route exact path="/onboarding/add-image" component={AddImagePage} />
        <Route
          exact
          path="/onboarding/create-password"
          component={CreateNewPassword}
        />

        {/* ADMIN */}

        <ActivatedAccountRoute>
          <MainDashboardLayout>
            <IsLoggedInRoute exact path="/" component={Dashboard} />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/messages"
              component={Message}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/messages"
              component={Message}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/messages"
              component={Message}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/home"
              component={Dashboard}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/home"
              component={Dashboard}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/home"
              component={Dashboard}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/document-processing"
              component={AdminDocProcessing}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/document-processing"
              component={AdminDocProcessing}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/fee"
              component={AdminFee}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/delivery-fees"
              component={AdminDeliveryFee}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/faq"
              component={AdminFaq}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/document-processing/:id"
              component={AdminDocumentProcessingDetails}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/communities"
              component={AdminCommunity}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/communities/:id"
              component={CommunityDetails}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/communities"
              component={AdminCommunity}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/communities/:id"
              component={CommunityDetails}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/members"
              component={AdminMember}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/members"
              component={AdminMember}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/event/:id"
              component={EventDetails}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/document-instructions"
              component={AdminDocProcessingInstruction}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/events"
              component={AdminEvent}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/events"
              component={AdminEvent}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/announcements"
              component={AdminAnnouncement}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/announcements"
              component={AdminAnnouncement}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/career-jobs"
              component={AdminCareerJob}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/career-jobs"
              component={AdminCareerJob}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/career-scholarships"
              component={AdminScholarshipJob}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/profile"
              component={EditProfile}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/profile"
              component={EditProfile}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/profile/user/:id"
              component={UserProfile}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/profile/user/:id"
              component={UserProfile}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/announcement/:id"
              component={AnnouncementDetails}
            />
            {/* USER */}

            <IsLoggedInRoute
              exact
              path="/dashboard/user"
              component={DocProcessing}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/member-profile"
              component={MemberProfile}
            />
            <IsLoggedInRoute
              exact
              path="/payment/verify-payment"
              component={VerifyPayment}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing/transcript-unofficial"
              component={TranscriptUnofficial}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing/transcript-official"
              component={TranscriptOfficial}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/secretariat"
              component={Secretariat}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/profile"
              component={EditProfile}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/profile"
              component={EditProfile}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/profile"
              component={EditProfile}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing"
              component={DocProcessing}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing/cart-orders"
              component={CartPage}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing/tracking"
              component={DocumentTracking}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing/tracking/:name"
              component={DocumentTrackingDetails}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/profile/:id"
              component={UserProfile}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/announcements"
              component={Announcement}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/careers"
              component={CareerHome}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/careers-details"
              component={CareerDetails}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/faq-session"
              component={FAQ}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/member-directory"
              component={MemberDirectory}
            />
            {/* <IsLoggedInRoute
              exact
              path="/dashboard/user/member-directory/:id"
              component={MemberProfile}
            /> */}
            <IsLoggedInRoute
              exact
              path="/dashboard/user/events"
              component={EventHome}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/communities"
              component={CommunityHome}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/people"
              component={PeopleHome}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/people/:id"
              component={StudentProfile}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing/official_letter"
              component={OfficialLetter}
            />
            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing/certificate"
              component={CertProcessing}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/announcement/:id"
              component={AnnouncementDetails}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/event/:id"
              component={EventDetails}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/document-processing/payment"
              component={PaymentBreakdownComponent}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/community/:id"
              component={CommunityDetails}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/create-event"
              component={CreateEvent}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/privacy-policy"
              component={PrivacyPolicy}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/user/terms&condition"
              component={TermsCondition}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/privacy-policy"
              component={PrivacyPolicy}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/privacy-policy"
              component={PrivacyPolicy}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/system-admin/terms&condition"
              component={TermsCondition}
            />

            <IsLoggedInRoute
              exact
              path="/dashboard/super-admin/terms&condition"
              component={TermsCondition}
            />
          </MainDashboardLayout>
          <Route component={Error404} />
        </ActivatedAccountRoute>
      </Switch>
    </Router>
  );
}

export default App;
